<template>
  <div class="page">
    <!-- 广告图 -->
    <Banner />
    <!-- 溯源查询 -->
    <Search />
    <!-- 溯源新闻 -->
    <News />
  </div>
</template>

<script>
import Banner from './components/banner.vue'
import Search from './components/search.vue'
import News from './components/news.vue'
export default {
  name: 'Home',
  components: {
    Banner,
    Search,
    News
  },
  data() {
    return {}
  },
  created() {
    console.log('首页')
  }
}
</script>

<style lang="scss" scoped></style>
